<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.studentDeletedList.push"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
    default-order-by="is_del"
  >
    <v-column-time value="注销时间" field="is_del"/>
    <v-column-student/>
    <el-table-column label="ID" prop="id"/>
    <v-column-admin value="注销者"/>
    <el-table-column label="手机号" prop="phone"/>
    <el-table-column label="注册来源" prop="store_name"/>
    <el-table-column label="会员卡号" prop="card_number"/>
    <el-table-column label="拥有课卡数量" prop="card_count"/>
    <el-table-column label="操作">
      <template v-slot="{ row }">
        <v-list-button icon="view" name="查看" :to="studentDeleteDetailTo(row.id)"/>

        <v-list-button
          v-if="isAdministrator"
          name="恢复"
          icon="restore"
          :is-last="true"
          @click="handleDelete(row.id)"
          :is-loading="isDeleting[row.id]"
          message="确定要恢复此账号吗？"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>姓名</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>注销时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>注册时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>注册来源</span>
              <span>{{ v.store_name || '小程序' }}</span>
            </div>
            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>
            <div class="list-item-detail">
              <span>会员卡号</span>
              <span v-if="v.card_number">{{ v.card_number }}</span>
              <span v-else class="info-color">未填写</span>
            </div>
            <div class="list-item-detail">
              <span>拥有课卡数量</span>
              <span>{{ v.card_count }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button icon="view" name="查看" :to="studentDeleteDetailTo(v.id)"/>

              <v-list-button
                v-if="isAdministrator"
                name="恢复"
                icon="restore"
                :is-last="true"
                @click="handleDelete(v.id)"
                :is-loading="isDeleting[v.id]"
                message="确定要恢复此账号吗？"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>

</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, restore } from '@/api/student';

export default {
  name: RouteConfig.studentDeletedList.name,
  data: () => ({
    RouteConfig,
    studentDeleteDetailTo: RouteConfig.studentDeleteDetail.to,
    isLoading: false,
    isStoringIds: [],
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {},
  }),
  computed: {
    ...mapGetters([
      'defaultStoreId',
      'isAdministrator',
      'isMobile',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.studentDeletedList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete(id) {
      if (!id) return this.$message.warning('缺少学员 ID，无法恢复该学员！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await restore(id);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
